import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Select, Form } from 'antd';

const { Option } = Select;

const PermissionForm = ({
  form,
}) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
  >
    <Form.Item
      rules={[
        { required: true, message: 'This input is required!' },
      ]}
      name="name"
      label="Name"
    >
      <Input placeholder="Permission Name" />
    </Form.Item>
    <Form.Item
      rules={[
        { required: true, message: 'This input is required!' },
      ]}
      label="Resource"
      name="resource"
    >
      <Input placeholder="Resource" />
    </Form.Item>
    <Form.Item
      rules={[
        { required: true, message: 'This input is required!' },
      ]}
      label="Method"
      name="method"
    >
      <Select
        allowClear
        showArrow
        style={{ width: '100%' }}
        placeholder="Select method"
      >
        <Option key="1" value="GET">
          GET
        </Option>
        <Option key="2" value="POST">
          POST
        </Option>
        <Option key="3" value="PUT">
          PUT
        </Option>
        <Option key="4" value="DELETE">
          DELETE
        </Option>
      </Select>
    </Form.Item>
  </Form>
);

PermissionForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

PermissionForm.defaultProps = {
  form: {},
};

export default PermissionForm;
